'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('onyxReadingRoomApp.appconfs.add', [])
  .controller('AppConfsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/add/index.js